module.exports = __webpack_public_path__ + "static/media/Alias Surface.411764e7.png";